import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    mercadoPago_pagos({ commit, dispatch }, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago/pagos', { params })
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_pagosId({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/pagos-show', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_pagosIdRefresh({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/pagos/'+form.id+'/refresh', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_stats() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago/stats')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_updateStoreOrden({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/update-store-orden', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_getOrdenes() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago/get-ordenes')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_getUsers() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago/get-users')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_createPago({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/create-pago', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_createSuscripcion({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/create-suscripcion', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_getSuscripcion({ commit, dispatch }, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago/get-suscripcion', { params })
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_obtenerSuscripcionesConPayments() {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/obtener-suscripciones-con-payments')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_obtenerSingularPayments() {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/obtener-singular-payments')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPago_cancelarSuscripcion({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago/cancelar-suscripcion', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    mercadoPago_marcarContactado({ commit, dispatch }, form) {
    return new Promise((resolve, reject) => {
        axios.post(Config.apiPath + 'mercado-pago/usuario-contacto', form)
            .then(
                response => {
                    resolve(response);
                })
            .catch(error => {
                reject(error.response);
            });
    });
    },

    
    
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};